// extracted by mini-css-extract-plugin
module.exports = {"preserveOutline":"CloseButton_preserveOutline__WKYX3","closeButton":"CloseButton_closeButton__2eoyR CloseButton_preserveOutline__WKYX3","img":"CloseButton_img__3F1q_"};